import { Backdrop, Button, Card, CardActions, CardContent, CircularProgress, Divider, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { base64Reader } from 'src/utils/storage/StrPhoto';
import CloseIcon from '@material-ui/icons/Close';

const CompressMaterial = require('compress.js').default;
const compressMaterial = new CompressMaterial();
const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function FilePopup({ open, onClose, FisNo, DosyaTipi, DosyaTipiText, className }) {
  const classes = useStyles();
  const [labelMaterial, setLabelMaterial] = useState("Dosya seçiniz...");
  const [loadingMaterial, setLoadingMaterial] = useState(false);
  if (!open) {
    return null;
  }
  // if (FisNo === ''){
  //   setLabel('Lütfen Malzeme Seçiniz!...');
  // }

  const handleChangeStatusMaterial = () => {

  }

  const handleSubmitMaterial = async (files, allFiles) => {
    setLoadingMaterial(true);
    let totalMaterial = files.length;
    let successMaterial = 0;
    for (let i = 0; i < files.length; i++) {
      const fileMaterial = files[i].file;
      const metaMaterial = files[i].meta;
      let base64ResultMaterial = "";
      if (metaMaterial.type.indexOf('image') !== -1) {
        try {
          const resizedImageMaterial = await compressMaterial.compress([fileMaterial], {
            quality: 1, // the quality of the image, max is 1,
            maxWidth: 1920, // the max width of the output image, defaults to 1920px
            maxHeight: 1920, // the max height of the output image, defaults to 1920px
            resize: true // defaults to true, set false if you do not want to resize the image width and height
          });
          const imgMaterial = resizedImageMaterial[0];
          base64ResultMaterial = imgMaterial.data
        } catch (compressError) {
          // EXIF date parsing hatasında orijinal dosyayı base64 olarak kullan
          console.warn('Görsel sıkıştırma hatası, orijinal dosya kullanılıyor:', compressError.message);
          base64ResultMaterial = await base64Reader(fileMaterial);
        }
      } else {
        base64ResultMaterial = await base64Reader(fileMaterial);
      }

      const dataMaterial = {
        Title: DosyaTipiText + ' - ' + metaMaterial.name,
        MIMEType: metaMaterial.type,
        ServiscePaperId: FisNo,
        DosyaTipi: DosyaTipi.toString(),
        FileData: base64ResultMaterial
      }
      const configMaterial = {
        headers: { 'Content-Type': 'application/json' }
      }
      await axios.post('/FileImportExport/ArtemismaterialFileUpload', dataMaterial, configMaterial)
        // eslint-disable-next-line
        .then(response => {
          successMaterial += response.data ? 1 : 0;
        })
    }
    allFiles.forEach(f => f.remove())
    if (totalMaterial === 0) {
      setLabelMaterial('Lütfen Dosya Seçiniz');
    } else {
      totalMaterial === successMaterial ?
        setLabelMaterial(totalMaterial === 1 ? 'Dosya Başarıyla Yüklendi' : `${totalMaterial} Adet Dosya Başarıyla Yüklendi.`)
        :
        setLabelMaterial(successMaterial + ' Adet Dosya Başarıyla Yüklendi. ' + (totalMaterial - successMaterial) + ' Adet Dosya Yüklenemedi!..');
    }
    setLoadingMaterial(false);
  }



  return (
    <Modal
      onClose={() => { setLabelMaterial("Dosya seçiniz..."); onClose() }}
      open={open}
    >
      <Card
        className={clsx(classes.root, className)}
      >
        <form>
          <CardContent color='secondary'>
            {
              loadingMaterial ?
                <Backdrop className={classes.backdrop} open={loadingMaterial}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                : <Dropzone
                  onChangeStatus={handleChangeStatusMaterial}
                  onSubmit={handleSubmitMaterial}
                  styles={{
                    dropzone: { minHeight: 200, maxHeight: 250 },
                  }}
                  inputContent={labelMaterial}
                  submitButtonContent="Yükle"
                  accept="image/*"
                  maxFiles={1}
                  minSize={0}
                  maxSize={8072000}
                  inputWithFilesContent={files => `${5 - files.length} ekle`}
                />
            }

          </CardContent>
          <Divider />
          <CardActions className={classes.actions}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={() => { setLabelMaterial("Dosya seçiniz..."); onClose() }}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

FilePopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default FilePopup;
